import { render } from "./Homepage.vue?vue&type=template&id=2b0f57ab&scoped=true"
import script from "./Homepage.vue?vue&type=script&lang=js"
export * from "./Homepage.vue?vue&type=script&lang=js"

import "./Homepage.vue?vue&type=style&index=0&id=2b0f57ab&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2b0f57ab"]])

export default __exports__